import { jsx } from "react/jsx-runtime";
import "react";
import TextField from "./TextField.esm.js";
import useConfigWithExtraValidation from "../../utils/form/useExtraFieldValidation.esm.js";
function getPhoneNumberError(value) {
  const trimmedValue = typeof value === "string" && value.trim();
  if (trimmedValue) {
    if (/\D/.test(trimmedValue)) {
      return "Must be numeric";
    }
    if (value.length !== 10) {
      return "Must be 10 digits";
    }
    return null;
  }
  return null;
}
function PhoneField(textFieldProps) {
  return /* @__PURE__ */ jsx(
    TextField,
    {
      ...textFieldProps,
      config: useConfigWithExtraValidation(textFieldProps.config, getPhoneNumberError),
      mask: {
        // Phone without extension
        mask: "(999) 999-9999",
        placeholder: "_",
        autoUnmask: true
      },
      autoComplete: "off",
      placeholder: "(___) ___-____"
    }
  );
}
PhoneField.propTypes = TextField.propTypes;
PhoneField.defaultProps = TextField.defaultProps;
export {
  PhoneField as default,
  getPhoneNumberError
};
